import versionsCache from '@atlassian/jira-cache/src/services/versions/index.tsx';
import log from '@atlassian/jira-common-util-logging/src/log';
import type { VersionId } from '../../../common/model';
import type { FieldOperation } from '../../model/types';
import { deleteAndSwapVersion as deleteAndSwapVersionRest } from '../../rest/delete';
import { transformSwapConfiguration } from './transformers';

export const deleteAndSwapVersion = (
	baseUrl: string,
	id: VersionId,
	swapConfiguration: FieldOperation[],
): Promise<void> =>
	deleteAndSwapVersionRest(baseUrl, id, transformSwapConfiguration(swapConfiguration)).then(
		(result) => {
			try {
				id && versionsCache.remove(id);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				log.safeErrorWithoutCustomerData(
					'project-directories.versions.cache.remove',
					error.message,
				);
			}
			return result;
		},
	);
